import { render } from "./dynamic-yield-template.vue?vue&type=template&id=3534bb76"
import script from "./dynamic-yield-template.vue?vue&type=script&lang=js"
export * from "./dynamic-yield-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__